import type { RouteObject } from "react-router-dom";
import { lazy } from "react";

const HomePage = lazy(() => import('../pages/home/page'));
const PurchasePage = lazy(() => import('../pages/purchase/page'));
const PurchaseSuccessPage = lazy(() => import('../pages/purchase/success/page'));
const DownloadPage = lazy(() => import('../pages/download/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const MembershipPage = lazy(() => import('../pages/membership/page'));
const MembershipSuccessPage = lazy(() => import('../pages/membership/success/page'));
const MembersPage = lazy(() => import('../pages/members/page'));
const TrojanIndexPage = lazy(() => import('../pages/trojan-index/page'));
const TrojanHorsePage = lazy(() => import('../pages/trojan-horse/page'));
const InsightsPage = lazy(() => import('../pages/insights/page'));
const InsightArticlePage = lazy(() => import('../pages/insights/article'));
const UnsubscribePage = lazy(() => import('../pages/unsubscribe/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/purchase",
    element: <PurchasePage />,
  },
  {
    path: "/purchase/success",
    element: <PurchaseSuccessPage />,
  },
  {
    path: "/download",
    element: <DownloadPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "/terms",
    element: <TermsPage />,
  },
  {
    path: "/membership",
    element: <MembershipPage />,
  },
  {
    path: "/membership/success",
    element: <MembershipSuccessPage />,
  },
  {
    path: "/members",
    element: <MembersPage />,
  },
  {
    path: "/trojan-index",
    element: <TrojanIndexPage />,
  },
  {
    path: "/trojan-horse",
    element: <TrojanHorsePage />,
  },
  {
    path: "/insights",
    element: <InsightsPage />,
  },
  {
    path: "/insights/:slug",
    element: <InsightArticlePage />,
  },
  {
    path: "/unsubscribe",
    element: <UnsubscribePage />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export default routes;
